<template>
  <v-app>
    <v-navigation-drawer v-model="drawerShown" app>
      <v-list-item>
        <v-list-item-icon class="mr-3">
          <v-icon x-large>mdi-account-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ profile.email }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ numberToMoney(totalBalance, profile.baseCurrency) }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-list>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(link, index) of links"
            :key="index"
            :to="link.to"
            exact
            link
          >
            <v-list-item-content>
              <v-list-item-title>{{ link.label }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <template v-slot:append>
        <div class="pa-3">
          <v-btn color="primary" block :loading="isLoading" @click="logout">
            Вийти
          </v-btn>
        </div>
      </template>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.mobile"
        @click="drawerShown = !drawerShown"
      />
      <v-toolbar-title>Budgetify</v-toolbar-title>
    </v-app-bar>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { getErrorMessage } from "@/helpers/errors";
import { numberToMoney } from "@/helpers/converters";

export default {
  name: "DefaultLayout",
  data() {
    return {
      isLoading: false,
      drawerShown: null,
      links: [
        {
          label: "Діаграма",
          to: { name: "Home" },
        },
        {
          label: "Рахунки",
          to: { name: "Accounts" },
        },
        {
          label: "Категорії",
          to: { name: "Categories" },
        },
        {
          label: "Налаштування",
          to: { name: "Settings" },
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["totalBalance"]),
    profile() {
      return this.$store.state.auth.profile;
    },
  },
  methods: {
    numberToMoney,
    ...mapActions(["showMessage", "fetchAccounts"]),
    async logout() {
      this.isLoading = true;
      await this.$router.push({ name: "Login" });
      this.$store.commit("LOGOUT");
      this.isLoading = false;
    },
    async loadAccounts() {
      try {
        await this.fetchAccounts();
      } catch (error) {
        this.showMessage(getErrorMessage(error));
      }
    },
  },
  mounted() {
    if (this.$route.name !== "Accounts") {
      this.loadAccounts();
    }
  },
};
</script>
